import logo from '@kargotech/tms-common/Assets/Images/Logo/ShipperPlatform/shipper.svg';
import shipperConfigs from './platform';

export default {
  ...shipperConfigs,
  logo,
  projectUrl: (global.location && global.location.origin) || 'https://shipper.kargo.tech'
};
